export default {
  CONTACT_TYPES_REPOSITORY: Symbol.for('CONTACT_TYPES_REPOSITORY'),
  GET_ALL_CONTACT_TYPES_QUERY: Symbol.for('GET_ALL_CONTACT_TYPES_QUERY'),
  CONTACT_TYPES_STATE_MANAGER: Symbol.for('CONTACT_TYPES_STATE_MANAGER'),
};
